import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
export class LodestoneScoreHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        return node.gameState.getScores().toTable();
    }
}
